import * as i0 from '@angular/core';
import { Component, SkipSelf, Host, Input, NgModule } from '@angular/core';
import * as i1 from 'devextreme-angular/core';
import { NestedOption, NestedOptionHost, CollectionNestedOption } from 'devextreme-angular/core';

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoSchedulerAppointmentDraggingComponent = /*#__PURE__*/(() => {
  class DxoSchedulerAppointmentDraggingComponent extends NestedOption {
    get autoScroll() {
      return this._getOption('autoScroll');
    }
    set autoScroll(value) {
      this._setOption('autoScroll', value);
    }
    get data() {
      return this._getOption('data');
    }
    set data(value) {
      this._setOption('data', value);
    }
    get group() {
      return this._getOption('group');
    }
    set group(value) {
      this._setOption('group', value);
    }
    get onAdd() {
      return this._getOption('onAdd');
    }
    set onAdd(value) {
      this._setOption('onAdd', value);
    }
    get onDragEnd() {
      return this._getOption('onDragEnd');
    }
    set onDragEnd(value) {
      this._setOption('onDragEnd', value);
    }
    get onDragMove() {
      return this._getOption('onDragMove');
    }
    set onDragMove(value) {
      this._setOption('onDragMove', value);
    }
    get onDragStart() {
      return this._getOption('onDragStart');
    }
    set onDragStart(value) {
      this._setOption('onDragStart', value);
    }
    get onRemove() {
      return this._getOption('onRemove');
    }
    set onRemove(value) {
      this._setOption('onRemove', value);
    }
    get scrollSensitivity() {
      return this._getOption('scrollSensitivity');
    }
    set scrollSensitivity(value) {
      this._setOption('scrollSensitivity', value);
    }
    get scrollSpeed() {
      return this._getOption('scrollSpeed');
    }
    set scrollSpeed(value) {
      this._setOption('scrollSpeed', value);
    }
    get _optionPath() {
      return 'appointmentDragging';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSchedulerAppointmentDraggingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSchedulerAppointmentDraggingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSchedulerAppointmentDraggingComponent,
      selectors: [["dxo-scheduler-appointment-dragging"]],
      inputs: {
        autoScroll: "autoScroll",
        data: "data",
        group: "group",
        onAdd: "onAdd",
        onDragEnd: "onDragEnd",
        onDragMove: "onDragMove",
        onDragStart: "onDragStart",
        onRemove: "onRemove",
        scrollSensitivity: "scrollSensitivity",
        scrollSpeed: "scrollSpeed"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSchedulerAppointmentDraggingComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoSchedulerAppointmentDraggingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSchedulerAppointmentDraggingModule = /*#__PURE__*/(() => {
  class DxoSchedulerAppointmentDraggingModule {
    /** @nocollapse */static ɵfac = function DxoSchedulerAppointmentDraggingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSchedulerAppointmentDraggingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSchedulerAppointmentDraggingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoSchedulerAppointmentDraggingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoSchedulerEditingComponent = /*#__PURE__*/(() => {
  class DxoSchedulerEditingComponent extends NestedOption {
    get allowAdding() {
      return this._getOption('allowAdding');
    }
    set allowAdding(value) {
      this._setOption('allowAdding', value);
    }
    get allowDeleting() {
      return this._getOption('allowDeleting');
    }
    set allowDeleting(value) {
      this._setOption('allowDeleting', value);
    }
    get allowDragging() {
      return this._getOption('allowDragging');
    }
    set allowDragging(value) {
      this._setOption('allowDragging', value);
    }
    get allowResizing() {
      return this._getOption('allowResizing');
    }
    set allowResizing(value) {
      this._setOption('allowResizing', value);
    }
    get allowTimeZoneEditing() {
      return this._getOption('allowTimeZoneEditing');
    }
    set allowTimeZoneEditing(value) {
      this._setOption('allowTimeZoneEditing', value);
    }
    get allowUpdating() {
      return this._getOption('allowUpdating');
    }
    set allowUpdating(value) {
      this._setOption('allowUpdating', value);
    }
    get _optionPath() {
      return 'editing';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSchedulerEditingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSchedulerEditingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSchedulerEditingComponent,
      selectors: [["dxo-scheduler-editing"]],
      inputs: {
        allowAdding: "allowAdding",
        allowDeleting: "allowDeleting",
        allowDragging: "allowDragging",
        allowResizing: "allowResizing",
        allowTimeZoneEditing: "allowTimeZoneEditing",
        allowUpdating: "allowUpdating"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSchedulerEditingComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoSchedulerEditingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSchedulerEditingModule = /*#__PURE__*/(() => {
  class DxoSchedulerEditingModule {
    /** @nocollapse */static ɵfac = function DxoSchedulerEditingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSchedulerEditingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSchedulerEditingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoSchedulerEditingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiSchedulerResourceComponent = /*#__PURE__*/(() => {
  class DxiSchedulerResourceComponent extends CollectionNestedOption {
    get allowMultiple() {
      return this._getOption('allowMultiple');
    }
    set allowMultiple(value) {
      this._setOption('allowMultiple', value);
    }
    get colorExpr() {
      return this._getOption('colorExpr');
    }
    set colorExpr(value) {
      this._setOption('colorExpr', value);
    }
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    get displayExpr() {
      return this._getOption('displayExpr');
    }
    set displayExpr(value) {
      this._setOption('displayExpr', value);
    }
    get fieldExpr() {
      return this._getOption('fieldExpr');
    }
    set fieldExpr(value) {
      this._setOption('fieldExpr', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get useColorAsDefault() {
      return this._getOption('useColorAsDefault');
    }
    set useColorAsDefault(value) {
      this._setOption('useColorAsDefault', value);
    }
    get valueExpr() {
      return this._getOption('valueExpr');
    }
    set valueExpr(value) {
      this._setOption('valueExpr', value);
    }
    get _optionPath() {
      return 'resources';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiSchedulerResourceComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiSchedulerResourceComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiSchedulerResourceComponent,
      selectors: [["dxi-scheduler-resource"]],
      inputs: {
        allowMultiple: "allowMultiple",
        colorExpr: "colorExpr",
        dataSource: "dataSource",
        displayExpr: "displayExpr",
        fieldExpr: "fieldExpr",
        label: "label",
        useColorAsDefault: "useColorAsDefault",
        valueExpr: "valueExpr"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiSchedulerResourceComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxiSchedulerResourceComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiSchedulerResourceModule = /*#__PURE__*/(() => {
  class DxiSchedulerResourceModule {
    /** @nocollapse */static ɵfac = function DxiSchedulerResourceModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiSchedulerResourceModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiSchedulerResourceModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxiSchedulerResourceModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoSchedulerScrollingComponent = /*#__PURE__*/(() => {
  class DxoSchedulerScrollingComponent extends NestedOption {
    get mode() {
      return this._getOption('mode');
    }
    set mode(value) {
      this._setOption('mode', value);
    }
    get _optionPath() {
      return 'scrolling';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoSchedulerScrollingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSchedulerScrollingComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoSchedulerScrollingComponent,
      selectors: [["dxo-scheduler-scrolling"]],
      inputs: {
        mode: "mode"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoSchedulerScrollingComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoSchedulerScrollingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoSchedulerScrollingModule = /*#__PURE__*/(() => {
  class DxoSchedulerScrollingModule {
    /** @nocollapse */static ɵfac = function DxoSchedulerScrollingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoSchedulerScrollingModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoSchedulerScrollingModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoSchedulerScrollingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiSchedulerViewComponent = /*#__PURE__*/(() => {
  class DxiSchedulerViewComponent extends CollectionNestedOption {
    get agendaDuration() {
      return this._getOption('agendaDuration');
    }
    set agendaDuration(value) {
      this._setOption('agendaDuration', value);
    }
    get allDayPanelMode() {
      return this._getOption('allDayPanelMode');
    }
    set allDayPanelMode(value) {
      this._setOption('allDayPanelMode', value);
    }
    get appointmentCollectorTemplate() {
      return this._getOption('appointmentCollectorTemplate');
    }
    set appointmentCollectorTemplate(value) {
      this._setOption('appointmentCollectorTemplate', value);
    }
    get appointmentTemplate() {
      return this._getOption('appointmentTemplate');
    }
    set appointmentTemplate(value) {
      this._setOption('appointmentTemplate', value);
    }
    get appointmentTooltipTemplate() {
      return this._getOption('appointmentTooltipTemplate');
    }
    set appointmentTooltipTemplate(value) {
      this._setOption('appointmentTooltipTemplate', value);
    }
    get cellDuration() {
      return this._getOption('cellDuration');
    }
    set cellDuration(value) {
      this._setOption('cellDuration', value);
    }
    get dataCellTemplate() {
      return this._getOption('dataCellTemplate');
    }
    set dataCellTemplate(value) {
      this._setOption('dataCellTemplate', value);
    }
    get dateCellTemplate() {
      return this._getOption('dateCellTemplate');
    }
    set dateCellTemplate(value) {
      this._setOption('dateCellTemplate', value);
    }
    get dropDownAppointmentTemplate() {
      return this._getOption('dropDownAppointmentTemplate');
    }
    set dropDownAppointmentTemplate(value) {
      this._setOption('dropDownAppointmentTemplate', value);
    }
    get endDayHour() {
      return this._getOption('endDayHour');
    }
    set endDayHour(value) {
      this._setOption('endDayHour', value);
    }
    get firstDayOfWeek() {
      return this._getOption('firstDayOfWeek');
    }
    set firstDayOfWeek(value) {
      this._setOption('firstDayOfWeek', value);
    }
    get groupByDate() {
      return this._getOption('groupByDate');
    }
    set groupByDate(value) {
      this._setOption('groupByDate', value);
    }
    get groupOrientation() {
      return this._getOption('groupOrientation');
    }
    set groupOrientation(value) {
      this._setOption('groupOrientation', value);
    }
    get groups() {
      return this._getOption('groups');
    }
    set groups(value) {
      this._setOption('groups', value);
    }
    get intervalCount() {
      return this._getOption('intervalCount');
    }
    set intervalCount(value) {
      this._setOption('intervalCount', value);
    }
    get maxAppointmentsPerCell() {
      return this._getOption('maxAppointmentsPerCell');
    }
    set maxAppointmentsPerCell(value) {
      this._setOption('maxAppointmentsPerCell', value);
    }
    get name() {
      return this._getOption('name');
    }
    set name(value) {
      this._setOption('name', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get resourceCellTemplate() {
      return this._getOption('resourceCellTemplate');
    }
    set resourceCellTemplate(value) {
      this._setOption('resourceCellTemplate', value);
    }
    get scrolling() {
      return this._getOption('scrolling');
    }
    set scrolling(value) {
      this._setOption('scrolling', value);
    }
    get startDate() {
      return this._getOption('startDate');
    }
    set startDate(value) {
      this._setOption('startDate', value);
    }
    get startDayHour() {
      return this._getOption('startDayHour');
    }
    set startDayHour(value) {
      this._setOption('startDayHour', value);
    }
    get timeCellTemplate() {
      return this._getOption('timeCellTemplate');
    }
    set timeCellTemplate(value) {
      this._setOption('timeCellTemplate', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'views';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiSchedulerViewComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiSchedulerViewComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiSchedulerViewComponent,
      selectors: [["dxi-scheduler-view"]],
      inputs: {
        agendaDuration: "agendaDuration",
        allDayPanelMode: "allDayPanelMode",
        appointmentCollectorTemplate: "appointmentCollectorTemplate",
        appointmentTemplate: "appointmentTemplate",
        appointmentTooltipTemplate: "appointmentTooltipTemplate",
        cellDuration: "cellDuration",
        dataCellTemplate: "dataCellTemplate",
        dateCellTemplate: "dateCellTemplate",
        dropDownAppointmentTemplate: "dropDownAppointmentTemplate",
        endDayHour: "endDayHour",
        firstDayOfWeek: "firstDayOfWeek",
        groupByDate: "groupByDate",
        groupOrientation: "groupOrientation",
        groups: "groups",
        intervalCount: "intervalCount",
        maxAppointmentsPerCell: "maxAppointmentsPerCell",
        name: "name",
        offset: "offset",
        resourceCellTemplate: "resourceCellTemplate",
        scrolling: "scrolling",
        startDate: "startDate",
        startDayHour: "startDayHour",
        timeCellTemplate: "timeCellTemplate",
        type: "type"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiSchedulerViewComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxiSchedulerViewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiSchedulerViewModule = /*#__PURE__*/(() => {
  class DxiSchedulerViewModule {
    /** @nocollapse */static ɵfac = function DxiSchedulerViewModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiSchedulerViewModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiSchedulerViewModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxiSchedulerViewModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DxiSchedulerResourceComponent, DxiSchedulerResourceModule, DxiSchedulerViewComponent, DxiSchedulerViewModule, DxoSchedulerAppointmentDraggingComponent, DxoSchedulerAppointmentDraggingModule, DxoSchedulerEditingComponent, DxoSchedulerEditingModule, DxoSchedulerScrollingComponent, DxoSchedulerScrollingModule };
